export default __webpack_public_path__ + "static/media/gallery_09.f3900582.jpg";